import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import { getLanguagesThunk } from './thunks'

const languagesSlice = createSlice({
  name: 'languages',
  initialState,
  reducers: {
    setLanguagesReady: (state) => {
      state.ready = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLanguagesThunk.fulfilled, (state, action) => {
      state.languages = action.payload
      state.ready = true
    })
  },
})

export const { setLanguagesReady } = languagesSlice.actions
export default languagesSlice.reducer
